import React from 'react'

import './styles/Practice.scss';
import backgroundImg from '../../images/logo_large.svg'


const PracticeHeader = props => (
  <div
    className="sub-title-bar"
    style={{
      backgroundImage: `url(${
        props.practice.backgroundImg ? props.practice.backgroundImg.orig : ""
      })`,
      backgroundColor: "#999",
      minHeight: `20vh`,
      backgroundSize: "cover",
      backgroundAttachment: "fixed",
      backgroundRepeat: "no-repeat",
      padding: "1em",
      backgroundPosition: "center center" //,'transformStyle': 'preserve-3d'
    }}
  >
    <div
      className="md-headline row  sub-title-bar-content"
      style={{
        display: "flex",
        "justifyContent": "space-between",
        "alignItems": "center",
        padding: "0"
      }}
    >
      {/* Practice Logo */}
      <div className="practice-logo">
        {props.practice.logo ? (
          <img width="72" alt="logo" src={props.practice.logo.thumb} />
        ) : null}
      </div>
    </div>

    {props.children ? <div className="menu-bar">{props.children}</div> : null}
    <hr
      style={{
        background: "#ffffff",
        width: "100%"
      }}
    />
    <div
      style={{
        "fontSize": "1.5em",
        color: "#ffffff",
        margin: "0 auto",
        "marginBottom": "0",
        "textAlign": "center"
      }}
    >
      {props.practice.name}
      <div className="headerPracticeType" style={{fontSize: "0.6em", marginTop: "0.5em"}}>{props.practiceType}</div>
    </div>
  </div>
);

export default PracticeHeader;



// WEBPACK FOOTER //
// ./src/components/practice/PracticeHeader.jsx